import React from 'react';
import '../../../../stylesheets/stylesLayout/connection-requests.scss';
import { ConnetionRequestSource } from '../../../../types/zinantis/connectionRequests/connectionRequestTypes';
import { ProviderConnectionRequests } from '../../../contextsProperty/ContextConnectionRequests';
import { ProviderConnectionRequestsAuxiliaryData } from '../../../contextsProperty/ContextConnectionRequestsAuxiliaryData';
import ZinantisRequestsSection from './ZinantisRequestsSection';

const ZinantisRequests = () => {
    return (
        <section className='connection-requests__page'>
            <ProviderConnectionRequestsAuxiliaryData>
                <ProviderConnectionRequests
                    requestedBy={ConnetionRequestSource.OWNER}
                >
                    <ZinantisRequestsSection />
                </ProviderConnectionRequests>
                <ProviderConnectionRequests
                    requestedBy={ConnetionRequestSource.AGENCY}
                >
                    <ZinantisRequestsSection />
                </ProviderConnectionRequests>
            </ProviderConnectionRequestsAuxiliaryData>
        </section>
    );
};

export default ZinantisRequests;
